import { Component, Input, OnInit } from '@angular/core';
import { trigger, transition, animate, keyframes, style } from '@angular/animations';
import { PaymentsService } from '../../core/services/payments.service';
import { CurrencyService } from '../../core/services/currency.service';
import { ToolsService } from '../../core/services/tools.service';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '../../core/services/analytics.service';
import { getCurrencySymbol } from '@angular/common';
import { PlansService } from '../../core/services/plans.service';
import { IntlService } from '../../core/services/intl.service';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  animations: [
    trigger('flyInOut', [
      transition(
        'void => *',
        animate(360, keyframes([style({ opacity: '0', top: '10px', offset: 0 }), style({ opacity: '1', top: '0px', offset: 1 })]))
      ),
    ]),
  ], // animations
})
export class PricingComponent implements OnInit {

  @Input() promoBannerActive;

  public providersAmount = 1;
  public plans;
  public freePlan;
  public selectedProPlanAnnually;
  public selectedProPlanMonthly;

  public showFeaturesPro = false;
  public showFeaturesProPlus = false;

  public selectedProPlusPlanAnnually;
  public selectedProPlusPlanMonthly;

  public supportEmail;

  public pricingOptions = [
    { key: 'year', text: this.translate.instant('LANDING.pricing.yearly') + ' (-20%)', fraction: 0.8 },
    { key: 'month', text: this.translate.instant('LANDING.pricing.monthly'), fraction: 1 },
  ];
  public selectedPricingOption;

  public providersAmountOptions = [1, 2, 3, 4, 5];

  public withoutSMSlabel;
  public withSMSlabel;

  public withSMS = true;
  public showAnnual = true;

  getCurrencySymbol = getCurrencySymbol;

  public availablePlans;

  @Input() ref: any;

  constructor(
    private paymentsService: PaymentsService,
    private currencyService: CurrencyService,
    public toolsService: ToolsService,
    private translate: TranslateService,
    private analytics: AnalyticsService,
    private plansService: PlansService,
    private intlService: IntlService
  ) {}

  ngOnInit() {
    this.selectedPricingOption = this.pricingOptions[0];
    this.withSMSlabel = this.translate.instant('SHARED.plansModal.with-sms')
    this.withoutSMSlabel = this.translate.instant('SHARED.plansModal.without-sms')

    this.supportEmail = this.intlService.getSupportEmail();
    const country = this.intlService.getCurrentCountry();
    this.paymentsService.getPlans(country).subscribe((res) => {
      const timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
      const currency = this.currencyService.getFromTimezone(timezone);

      // Select merchant currency
      let plans = res.find((v) => v.currency === currency);
      if (!plans) {
        plans = res[0];
      }

      this.freePlan = plans.plans.find((p) => p.bukId === 'free');

      // Only on free, change to selected currency
      this.freePlan.currency = plans.currency;

      this.availablePlans = plans;
      this.refreshPrices();
    });
  }

  refreshPrices() {

    const perProviderPlans = this.plansService.getPlansBasedOnSettings('pro', this.withSMS, this.availablePlans);
    this.selectedProPlanAnnually = perProviderPlans.annual;
    this.selectedProPlanMonthly = perProviderPlans.monthly;

    const proPlusPlans = this.plansService.getPlansBasedOnSettings('pro_plus', this.withSMS, this.availablePlans);
    this.selectedProPlusPlanAnnually = proPlusPlans.annual;
    this.selectedProPlusPlanMonthly = proPlusPlans.monthly;

  }

  analyticsEvent(action, category = 'priceSection') {
    this.analytics.trackEvent(action, category);
  }

  toggleAnnual() {
    this.showAnnual = !this.showAnnual;
  }

  toggleSMS() {
    this.withSMS = !this.withSMS;
    this.refreshPrices();
  }

  getFlatPrice(plan) {
    if (plan?.flatPriceWithoutVat) {
      return plan.flatPriceWithoutVat + plan.priceWithoutVat;
    }
    return (plan?.flatPrice + plan?.price) || 0;
  }

  getPrice(plan) {
    if (plan?.priceWithoutVat) {
      return plan.priceWithoutVat;
    }
    return plan?.price || 0;
  }

}
